/* eslint-disable camelcase */
import React, {
  useEffect,
  useCallback,
} from 'react';
import {
  getStatus,
} from 'redux-resource';
import {
  shallowEqual,
  useDispatch,
  useSelector,
} from 'react-redux';
import {
  toast,
} from 'react-toastify';

import {
  coreActions,
  coreSelectors,
} from '@gymcloud/core';

import {
  history,
} from 'web-history';

import {
  Icon,
  Video,
  Author,
  Button,
  Spinner,
  NotFound,
  ContentWrapper,
  MarkdownRenderer,
} from 'web-components';

import {
  Flex,
  Text,
  TextBreadcrumbs,
} from 'web-styled';

import * as S from './styled';

type Props = {
  id: number,
  clientInfo: any,
};

const PersonalExercises = ({ id, clientInfo }: Props) => {
  const resourceType = 'exercises';
  const mapState = useCallback(state => ({
    readStatus: getStatus(
      state,
      [
        `${resourceType}.meta[${id}].readStatus`,
        `${resourceType}.requests.getEntity.status`,
      ],
      true,
    ),
    exercise: coreSelectors.getResourceById(
      resourceType,
      id,
    )(state),
  }), [id]);

  const {
    readStatus,
    exercise,
  } = useSelector(mapState, shallowEqual);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      coreActions.requestFullEntity({ id, resourceType }),
    );
  }, [id]);

  const handleAddBest = () => {
    toast.info('This function will be available soon.');
  };

  const profile = clientInfo?.user_profile;

  return (
    <>
      {readStatus.succeeded && (
        <ContentWrapper
          header={(
            <Flex align="center" spacing={10}>
              <Button
                appearance="link"
                onClick={() => {
                  history.goBack();
                }}
              >
                <Icon type="fa fa-chevron-left" />
              </Button>
              <TextBreadcrumbs active>
                {exercise.name}
              </TextBreadcrumbs>
            </Flex>
          )}
        >
          <Flex
            width="100%"
            spacing={15}
            padding="30px 20px"
          >
            <Flex fillSpace column spacing={15}>
              <Flex
                width="100%"
                column
              >
                <Video
                  id={exercise?.video_id}
                  src={exercise?.video_url}
                  title={exercise?.name}
                  height="500px"
                  entityType="exercise"
                />
              </Flex>
              <Flex width="100%" justify="flex-end">
                <Author
                  avatar={exercise?.author?.user_profile?.avatar?.thumb?.url}
                  fullName={exercise?.author_full_name}
                />
              </Flex>
              <Flex width="100%">
                <MarkdownRenderer
                  source={exercise?.description}
                  placeholder="A description has not been assigned yet."
                />
              </Flex>
            </Flex>
            <Flex
              column
              align="center"
              justify="center"
              flex="0 0 33.3333333%"
              spacing={30}
              padding="30px"
            >
              <Text
                size="18px"
                color="#9ea0a1"
              >
                Personal Best
              </Text>
              <Button
                ghost
                spacing="large"
                appearance="primary"
                onClick={handleAddBest}
              >
                Add New Personal Best
              </Button>
              <S.Trophy />
              <Text
                size="14px"
                color="#9ea0a1"
              >
                {`${profile.first_name} ${profile.last_name} `}
                 doesn’t have any peronal best added.
              </Text>
            </Flex>
          </Flex>
        </ContentWrapper>
      )}

      {readStatus.pending && (
        <Spinner message="Loading Exercise..." />
      )}

      {readStatus.failed && (
        <NotFound title={`Exercise Not Found (${id})`} />
      )}
    </>
  );
};

export default PersonalExercises;
